var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCityDarkRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 122,
    viewBox: "0 0 405 122",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#333",
    points: "1224.376 2287.614 1225.365 2278.764 1227.922 2255.905 1197.738 2252.519 1196.75 2261.368 1179.813 2259.464 1172.533 2264.625 1157.807 2262.97 1158.546 2256.335 1151.922 2255.587 1126.891 2252.784 1126.151 2259.419 1090.815 2255.451 1065.783 2252.648 1046.644 2250.501 1048.703 2232.062 1028.832 2229.833 1029.82 2220.984 995.215 2217.099 993.978 2228.163 993.073 2236.279 959.946 2232.561 951.044 2212.15 910.63 2213.585 906.926 2246.768 885.576 2244.373 887.387 2228.155 889.944 2205.295 878.168 2203.973 879.895 2188.481 866.648 2187 864.422 2206.905 861.933 2229.153 846.475 2227.422 844.098 2248.68 827.901 2246.866 826 2263.824 857.655 2267.376 1228.691 2309 1231 2288.354",
    transform: "translate(-826 -2187)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCityDarkRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/city-dark-right.e29366e6.svg";
export { ForwardRef as ReactComponent };